import Vue from 'vue'
import VueRouter from 'vue-router'
import List from '../views/List.vue'
import Detail from '../views/Detail.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'list',
        component: List
    },
    {
        path: '/:id',
        name: 'detail',
        component: Detail
    }
]

// /listing/{id}/concierge
const BASE_URL = location.pathname.split('/').slice(0, 3).join('/') + '/concierge'

const router = new VueRouter({
    mode: 'history',
    base: BASE_URL,
    routes
})

export default router
